// Standalone-mode analogue of computeEncounterUrl: route by recording status.

import { Appointment } from '@/types/appointment';

export function computeAppointmentUrl(appointment: Appointment): string {
  const appointmentId = appointment.id;
  const recordingStatus = appointment.recording?.status;

  // Unrecorded or in-progress → recording page; completed → validation/note.
  if (!recordingStatus || recordingStatus === 'pending' || recordingStatus === 'failed') {
    return `/recording/${appointmentId}`;
  }
  if (recordingStatus === 'completed') {
    return `/case/${appointmentId}/validation`;
  }
  if (recordingStatus === 'recording') {
    return `/recording/${appointmentId}`;
  }
  return `/case/${appointmentId}/validation`;
}
